import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './appointmentInfo.module.css';

const AppointmentTextHeader = ({ text }) => (
  <div className={classnames(styles.outer, { [styles.confirming]: true })}>
    <div className={styles.container}>
      <span className={styles.time}>
        <span>{text}</span>
      </span>
    </div>
  </div>
);

AppointmentTextHeader.propTypes = {
  text: PropTypes.string,
};

export default AppointmentTextHeader;
